<section class="app-promo">
    <div class="container">
        <div class="app-promo-banner">
            <div class="app-promo-text">
                <h2>{{ title }}</h2>
                <p class="app-promo-sub">{{ subtitle }}</p>
                <ul class="app-promo-features">
                    <li *ngFor="let feature of features">
                        <img class="check" src="resources/assets/images/prototype/promo-app-checkmark-icon.svg" alt="" aria-hidden="true">
                        <span>{{ feature }}</span>
                    </li>
                </ul>
                <button class="app-promo-cta" type="button" (click)="onDownloadCard()" *ngIf="walletUrl">
                    <img src="resources/assets/images/prototype/promo-app-download-icon.svg" alt="" aria-hidden="true">
                    <span>Descarga la tarjeta digital</span>
                </button>
            </div>
        </div>
    </div>
</section>
